import { useTranslation } from 'react-i18next';

export function Channels(): JSX.Element {
  const { t } = useTranslation();
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold text-brand-dark mb-4">Channels</h1>
      <div className="card">
        <p className="text-brand-muted">TODO: screen implementation (TELECLAW-3X)</p>
      </div>
    </div>
  );
}
